(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueController', QueueController);

    QueueController.$inject = ['$stateParams', '$state', '$scope', 'Queue', 'ParseLinks', 'AlertService', 'TabActionsQueueRetry', 'pagingParams', 'paginationConstants', 'TabObjects', '$uibModal'];

    function QueueController($stateParams, $state, $scope, Queue, ParseLinks, AlertService, TabActionsQueueRetry, pagingParams, paginationConstants, TabObjects, $uibModal) {
        var vm = this;

        //Aggiunta per Queue
        vm.transition = transition;
        vm.queue = [];
        vm.checkQueueEmpty = true;
        vm.now = [];
        vm.systemItemLimit = 10;
        vm.once = [];
        vm.scheduled = [];
        vm.completed = [];
        vm.filter = {};

        //vm.predicates = {'insertDateTime': false};
        vm.page = 0;
        vm.applyFilterPage = false;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.systemPredicates = pagingParams.systemPredicates;

        vm.picker = {
            start: false,
            end: false
        };

        vm.objects = [];
        vm.currentState = "queues";
        vm.filter.objectId = "-1";
        vm.filter.status = "all";
        vm.filter.start = null;
        vm.filter.stop = null;
        vm.obj = null;

        var filter = localStorage.getItem(vm.currentState);
        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.filter.objectId = filter.objectId;
                vm.filter.status = filter.status;
                vm.filter.start = filter.start;
                vm.filter.stop = filter.stop;
            }
        }

        vm.repeatable = pagingParams.repeatable;
        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.objectPage = 0;

        function sort() {
            return ['lastModifiedDate,desc'];
        }

        vm.loadAll = function () {

            var dataNow = {
                type: "now",
                completed: false,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemNowPage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataNow, onSuccessNow, onErrorNow);

            function onSuccessNow(data, headers) {

                vm.now = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemNowTotalItems = headers('X-Total-Count');
                vm.systemNowQueryCount = vm.systemNowTotalItems;
                vm.systemNowPage = pagingParams.systemNowPage;

                for (var i = 0; i < data.length; i++) {
                    vm.now.push(data[i]);
                }
                if(vm.now.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if (vm.systemNowPage === 0 && vm.systemNowPage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorNow(error) {
                AlertService.error(error.data.message);
            }

            var dataOnce = {
                type: "once",
                completed: false,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemOncePage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataOnce, onSuccessOnce, onErrorOnce);

            function onSuccessOnce(data, headers) {

                vm.once = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemOnceTotalItems = headers('X-Total-Count');
                vm.systemOnceQueryCount = vm.systemOnceTotalItems;
                vm.systemOncePage = pagingParams.systemOncePage;

                for (var i = 0; i < data.length; i++) {
                    vm.once.push(data[i]);
                }
                if(vm.once.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if (vm.systemOncePage === 0 && vm.systemOncePage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorOnce(error) {
                AlertService.error(error.data.message);
            }

            var dataScheduled = {
                type: "scheduled",
                completed: false,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemScheduledPage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataScheduled, onSuccessScheduled, onErrorOnceScheduled);

            function onSuccessScheduled(data, headers) {

                vm.scheduled = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemScheduledTotalItems = headers('X-Total-Count');
                vm.systemScheduledQueryCount = vm.systemScheduledTotalItems;
                vm.systemScheduledPage = pagingParams.systemScheduledPage;

                for (var i = 0; i < data.length; i++) {
                    vm.scheduled.push(data[i]);
                }
                if(vm.scheduled.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if (vm.systemScheduledPage === 0 && vm.systemScheduledPage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorOnceScheduled(error) {
                AlertService.error(error.data.message);
            }

            var dataCompleted = {
                type: "completed",
                completed: true,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemCompletedPage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataCompleted, onSuccessCompleted, onErrorOnceCompleted);

            function onSuccessCompleted(data, headers) {

                vm.completed = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemCompletedTotalItems = headers('X-Total-Count');
                vm.systemCompletedQueryCount = vm.systemCompletedTotalItems;
                vm.systemCompletedPage = pagingParams.systemCompletedPage;

                for (var i = 0; i < data.length; i++) {
                    vm.completed.push(data[i]);
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if(vm.completed.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if (vm.systemCompletedPage === 0 && vm.systemCompletedPage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorOnceCompleted(error) {
                AlertService.error(error.data.message);
            }

            vm.objects = [];
            vm.objectPage = 0;

            // Restore the selected object after loading objects
            var savedObjectId = vm.filter.objectId;
            vm.loadAllObject("", function() {
                if (savedObjectId && savedObjectId !== "-1") {
                    // Find the object in the loaded list
                    var selectedObj = vm.objects.find(function(obj) {
                        return obj.id == savedObjectId;
                    });
                    if (selectedObj) {
                        vm.obj = selectedObj;
                    }
                }
            });
        };

        vm.loadAllObject = function (stringToSearch, callback) {

            TabObjects.byQueue({
                page: vm.objectPage,
                size: 20,
                searchObj: stringToSearch
            }, onSuccessObject, onErrorObject);

            function onSuccessObject (data, headers){
                vm.objectLinks = ParseLinks.parse(headers('link'));
                vm.objectTotalItems = headers('X-Total-Count');

                if(vm.objectPage === 0){
                    var all = {
                        id: -1,
                        objectUniqueCode: "ALL",
                        objectName: "ALL"
                    };
                    vm.objects.push(all);
                }

                for (var i = 1; i < data.length+1; i++) {
                    if(vm.objects.indexOf(data[i-1]) === -1)
                        vm.objects.push(data[i-1]);
                }

                // Callback
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }

            function onErrorObject() {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }
        };

        vm.searchObj = function(stringToSearch, paste) {
            vm.objects = [];
            vm.objectPage = 0;
            if(paste) {
                var pasted = event.clipboardData.items[0];
                pasted.getAsString(function (data) {
                    vm.pstObj = data;
                    $scope.$apply();
                    vm.loadAllObject(vm.pstObj);
                });
            } else {
                vm.loadAllObject(stringToSearch);
            }
        };

        vm.loadPageObject = function (page) {
            if (page <= vm.objectLinks['last']) {
                vm.objectPage = page;
                vm.loadAllObject("");
            }
        };

        vm.selectObject = function (obj) {
            vm.filter.objectId = obj.id;
        };

        vm.applyFilter = function(){
            if(vm.filter.start < vm.filter.stop || vm.filter.start === vm.filter.stop){
                // Save the current object selection
                if (vm.obj && vm.obj.id) {
                    vm.filter.objectId = vm.obj.id;
                }
                localStorage.setItem(vm.currentState, JSON.stringify(vm.filter));
                vm.page = 0;
                vm.applyFilterPage = true;
                vm.loadAll();
            } else {
                AlertService.error("Error validation date.");
            }
        };

        vm.clear = function(){
            vm.filter = {};
            vm.filter.objectId = "-1";
            vm.filter.status = "all";
            vm.filter.start = null;
            vm.filter.stop = null;
            vm.obj = null; // Clear the object selection
            localStorage.setItem(vm.currentState, JSON.stringify(vm.filter));
            vm.applyFilterPage = false;
            $state.go('queues', {}, { reload: true });
        };

        vm.findIndexDate = function (array){
            for(var i = 0; i < array.length; i++){
                if(array[i].executionDatetime !== null){
                    return i;
                }
            }
        };

        vm.forceCompletion = function (queue){
            $uibModal.open({
                templateUrl: 'app/entities/queue/queues-forced-dialog.html',
                controller: 'QueueForcedDialog',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Queue', function (Queue) {
                        return Queue.get({id: queue.id});
                    }]
                }
            }).result.then(function () {
                $state.go('queues', null, {reload: true});
            }, function () {
                $state.go('queues');
            });
        };

        vm.showCron = function(stopped){
            if(stopped)
                return "Start Execution";
            else return "Stop Execution";
        };

        vm.muteCron = function(scheduled){
            if(!scheduled.stopped){
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queues-stop-dialog.html',
                    controller: 'QueueStopDialog',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function (Queue) {
                            return Queue.get({id: scheduled.id});
                        }]
                    }
                }).result.then(function () {
                    $state.go('queues', null, {reload: true});
                }, function () {
                    $state.go('queues');
                });
            } else {
                Queue.stopCron({id: scheduled.id}, onSuccessFc, onErrorFc);

                function onSuccessFc(data) {
                    vm.loadAll();
                }

                function onErrorFc() {}
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.queue = [];
            var orderCall = vm.loadAll();
        };

        vm.loadAll();

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.systemNowPage = page;
            vm.systemOncePage = page;
            vm.systemScheduledPage = page;
            vm.systemCompletedPage = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                systemNowPage: vm.systemNowPage,
                systemOncePage: vm.systemOncePage,
                systemScheduledPage: vm.systemScheduledPage,
                systemCompletedPage: vm.systemCompletedPage,
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();


            //broke when you go to fast
            //for now, it shows the result then return without filter
            // try to put vm.loadPage instead of vm.transition


            // idea : cancel the search bar and try with the filter in the header if they have the same issue


        };
    }
})();
